import { Menu, Text } from "@mike/crt";
import { Page } from "../components/Page";

const projects = [
  {
    label: "Coming Soon",
    description: "A cool project",
  },
  {
    label: "Coming Soon",
    description: "Another cool project",
  },
  {
    label: "Coming Soon",
    description: "Can you believe it? Yet another cool project",
  },
];

export function ProjectsPage() {
  const items = projects.map((project) => ({
    label: project.label,
    action: () => {
      console.log(`Selected: ${project.label}`);
    },
  }));

  return (
    <Page>
      <Text fontSize={42} color="#90d0ff" marginBottom={20}>
        PROJECTS
      </Text>
      <Text fontSize={14} color="rgba(100, 160, 200, 0.6)" marginBottom={60}>
        SELECT A PROJECT TO VIEW DETAILS
      </Text>
      <Menu items={items} />
    </Page>
  );
}
